<script setup lang="ts">
interface Props {
  icon?: string[];
  iconColor?: string;
  backgroundColor: string;
  size?: string;
}

withDefaults(defineProps<Props>(), {
  size: 'w-16 h-16',
});

export interface IIconCircle extends Props {}
</script>
<template>
  <div
    class="rounded-full flex items-center justify-center border-4 border-white shadow-bottom"
    :class="[backgroundColor, size]"
  >
    <fa-icon v-if="icon" :icon="icon" :class="iconColor" />
  </div>
</template>
